module.exports = __webpack_public_path__ + "static/media/AddUsers.6571c317.svg";